import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import { GetNetsuiteItemsCancelToken } from "../../../services/CourseService";
import {
  DeletePmc,
  GetListofProgramCancelToken,
  ListProgrammeFilters,
} from "../../../services/ProgramService";
import { handleTableScroll } from "../../../utils/commonFunction";
import {
  RenderProgrammeType,
  RenderSchool,
} from "../../../utils/CommonGroupingItem";
import { RenderPMCStatus } from "../../../utils/CommonStatusItems";
import PermissionsGate from "../../../utils/permissionGate";
import DataTableComponent from "../../common/DataTableComponent";
import { TrimText } from "../../common/TrimText";
import { tokens } from "../../../public/tokens";

const Program = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [school, setSchool] = useState({arr:[], checkObj:{}});
  const [type, setType] = useState({arr:[], checkObj:{}});
  const [NQF, setNQF] = useState({arr:[], checkObj:{}});
  const [status, setStatus] = useState({arr:[],checkObj:{}});
  const [enableStudypathLink, setEnableStudypathLink] = useState({arr:[],checkObj:{}});
  const [articulations, setArticulations] = useState({arr:[],checkObj:{}});
  const [loading, setloading] = useState(true);
  const [updateData, setUpdateData] = useState(Date.now());
  const [filterData, setFilterData] = useState({status : [], school : [], type:[], NQF:[], articulations:[]})
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "name",
    sortOrder: "asc",
  });
  const [totalRows, setTotalRows] = useState(0);
  const [netsuiteList, setNetsuiteList] = useState([]);
  const [dataProcessed, setDataProcessed] = useState([]);
  const cancelTokenSources = useRef([]);
  
  useEffect(() => {
    handleTableScroll()
  }, [loading])

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })

  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterstatePMCProgrammes"));
    if (storedFilters) {
      storedFilters?.status && setStatus(storedFilters.status);
      storedFilters?.school && setSchool(storedFilters.school);
      storedFilters?.type && setType(storedFilters.type);
      storedFilters?.NQF && setNQF(storedFilters.NQF);
      storedFilters?.enableStudypathLink && setEnableStudypathLink(storedFilters.enableStudypathLink);
      storedFilters?.articulations && setArticulations(storedFilters.articulations);
    }
  }, []);
  useEffect(() => {
    const filterState = {
      status,
      school,
      type,
      NQF,
      enableStudypathLink,
      articulations
    };
    localStorage.setItem("filterstatePMCProgrammes", JSON.stringify(filterState));
  }, [status, school, type, NQF, enableStudypathLink, articulations]);
  useEffect(() => {
    const getProgram = async () => {      
      cancelTokenSources.current.forEach(source => {
        source.cancel('New request made');
      });
      cancelTokenSources.current = [];
      
      const source = axios.CancelToken.source();
      cancelTokenSources.current.push(source);
      
      try {
        const payload = {
          page:tableState.page,
          limit:tableState.perPage,
          key:tableState.sortKey,
          sort:tableState.sortOrder,
          search : search,
          exportStatus:"false",
          viaStatus:status?.arr,
          viaSchool:school?.arr,
          viaType:type?.arr,
          viaNqfLevel:NQF?.arr,
          viaEnableStudypathLink: enableStudypathLink.arr,
          viaArticulations: articulations?.arr
        }
        const res = await GetListofProgramCancelToken(payload, source.token);
        if (res.status === 200) {
          setData(res.data.data);
          setTotalRows(res.data.total)
          
        }
        if(netsuiteList.length == 0){
          const data2 = await GetNetsuiteItemsCancelToken(
              'All',
          );
          setNetsuiteList(
            data2 && data2.data && data2.data.data && data2.data.data.items
            ? data2.data.data.items
            : []
          );
        }
        setloading(false);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false);
        }
      }
    };
    setloading(true);
    getProgram();
    return () => {
      cancelTokenSources.current.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [updateData, tableState, school, status, search, type, NQF, enableStudypathLink, articulations]);
  
  useEffect(() => {
    if (data && data.length > 0) {
      const updatedData = data.map((item) => {
        const matchedNetsuite = netsuiteList.find((i) => i.id == item.netsuite_product);
        return {
          ...item,
          netsuite_product_name: matchedNetsuite ? matchedNetsuite.displayname : "-",
        };
      });
      setDataProcessed(updatedData);
    } else {
      setDataProcessed([]);
    }
  }, [netsuiteList, data]);
  
  useEffect(() => {
    const filterSource = axios.CancelToken.source();
    const getFilters = async () =>{
      try {
        const res = await ListProgrammeFilters(filterSource.token);
        if(res.status==200){
          setFilterData({...res.data, status : res.data.statusListFilter, school : res.data.SchoolListFilter, NQF:res.data?.nqfLevel, type:res.data?.type, enableStudypathLink:res.data?.EnableStudypathLink, articulations:res.data?.articulations})
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }
    
    getFilters()
    return () => {
      filterSource.cancel('Component unmounted');      
    };
  }, [updateData]);
  
  usePermissionGuardRedirect(['pmcpview']);
  
  const columns = [
    {
      name: "Name",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => (
        <PermissionsGate
        scopes={["pmcpedit"]}
        RenderError={() => (
          <span title={row.name} className="feature-name">
          {" "}
          <span className="textLimit100">{row.name}</span>
          </span>
        )}
        >
        <Link
        to={`/program-management-center/programmes/programme/open/${row.id}`}
        title={row.name}
        className="as-text-blue curser feature-name"
        >
        <span title={row.name} className="textLimit100">
        {row.name}
        </span>
        </Link>
        </PermissionsGate>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      cell: (row) =>
        row?.status != null ? RenderPMCStatus(row?.status).html : "-",
    },
    {
      name: "Type",
      selector: "qualification_type",
      sortField: "qualification_type",
      sortable: true,
      cell: (row) =>
        row?.qualification_type != null ? RenderProgrammeType(row?.qualification_type).html : "-",
    },
    {
      name: "Code",
      selector: "Code",
      sortField: "Code",
      sortable: true,
      cell: (row, index) => (
        <div className="ticket-id">
        <span title={row.Code} className="overflow-ellipsis2">
        {row.Code ? TrimText(row.Code, 10) : "-"}
        </span>
        </div>
      ),
    },
    
    {
      name: "SAQA Link",
      selector: "SAQA_Name",
      sortField: "SAQA_Name",
      sortable: true,
      cell: (row) =>
        row.SAQA_Link ? (
        <a
        href={
          row.SAQA_Link.includes("http")
          ? row.SAQA_Link
          : "http://" + row.SAQA_Link
        }
        target={"_blank"}
        className="as-text-blue curser"
        title={row.SAQA_Name}
        >
        {TrimText(row.SAQA_Name, 15)}
        </a>
      ) : (
        "-"
      ),
    },    
    {
      name: "NQF",
      selector: "NQF_Level",
      sortField: "NQF_Level",
      sortable: true,
      cell: (row) => <div title={row?.NQF_Level}>{row?.NQF_Level}</div>,
    },
    {
      name: "School",
      selector: "School",
      sortField: "School",
      sortable: true,
      cell: (row) => row?.School ? <span className="feature-name"><span className="textLimit100">{RenderSchool(row?.School).html}</span></span> : "-",
    },
    {
      name: "Netsuite Product",
      selector: "netsuite_product",
      sortField: "netsuite_product",
      sortable: true,
      cell: (row) => (<><span className="textLimit50" title={row.netsuite_product_name}>{row.netsuite_product_name ? row.netsuite_product_name : "-" }</span></>),
    },
    {
      name: "Study Path Enabled",
      selector: "EnableStudyPathLink",
      sortField: "EnableStudyPathLink",
      sortable: true,
      cell: (row) => (
        <div style={{display: "flex", justifyContent: "center"}} title={row?.EnableStudypathLink == 1 ? "Yes" : "No"}>
        {row?.EnableStudypathLink == 1 
          ? <i className="fal fa-check check-true"></i> 
          : <i className="fal fa-times no-cross"></i>
        }
        </div>
      )
    },
    {
      name: "Articulation Options",
      selector: "articulations",
      sortField: "articulations",
      sortable: true,
      cell: (row) => {
  const value = row?.articulations ?? 0;
        return ( <div style={ value === 0? {
                  color: tokens.colors.states.alert.default,
                  fontWeight: tokens.typography.fontWeights.bold,
                }
                : undefined
            }
            title={value}>
            {value}
          </div>
        );
      },
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
        <div className="as-buttons">
        <PermissionsGate
        scopes={["pmcpedit"]}
        RenderError={() => (
          <button
          className="btn btn-primary rounded-circle"
          title="Open"
          disabled
          >
          <i className="fal fa-folder-open"></i>
          </button>
        )}
        >
        <Link
        to={`/program-management-center/programmes/programme/open/${row.id}`}
        className="btn btn-primary rounded-circle"
        title="Open"
        >
        <i className="fal fa-folder-open"></i>
        </Link>
        </PermissionsGate>
        
        <div className="dropdown btn-dropdown-item">
        <button
        className="btn btn-primary rounded-circle dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        title="More"
        >
        <i className="fal fa-ellipsis-h-alt"></i>
        </button>
        <div
        className="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
        >
        <PermissionsGate
        scopes={["pmcpadd"]}
        RenderError={() => (
          <button
          className="btn btn-primary rounded-circle"
          title="Duplicate"
          disabled
          >
          <i className="fal fa-copy"></i>
          </button>
        )}
        >
        <Link
        to={`/program-management-center/programmes/programme/duplicate/${row.id}`}
        className="btn btn-primary rounded-circle"
        title="Duplicate"
        >
        <i className="fal fa-copy"></i>
        </Link>
        </PermissionsGate>
        <PermissionsGate
        scopes={["pmcpview"]}
        RenderError={() => (
          <button
          className="btn btn-primary rounded-circle"
          title="Programme View"
          disabled
          >
          <i className="fal fa-eye"></i>
          </button>
        )}
        >
        <Link
        to={`/program-management-center/exportProgramme/${row.id}`}
        target="_blank"
        className="btn btn-primary rounded-circle"
        title="View Programme"
        >
        <i className="fal fa-eye"></i>
        </Link>
        </PermissionsGate>
        
        <PermissionsGate
        scopes={["pmcpdelete"]}
        RenderError={() => (
          <button
          className="btn btn-danger rounded-circle"
          title="Delete"
          disabled
          >
          <i className="fal fa-trash-alt"></i>
          </button>
        )}
        >
        <button
        title="Delete"
        className="btn btn-danger rounded-circle"
        onClick={() => handleDelete(row.id)}
        >
        <i className="fal fa-trash-alt"></i>
        </button>
        </PermissionsGate>
        </div>
        </div>
        </div>
        </div>
      ),
    },
  ];
  
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--button-color)",
      cancelButtonColor: "var(--states-alert)",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeletePmc({ id: id })
        .then((res) => {
          Swal.fire("Deleted!", "Programme has been deleted.", "success");
          setUpdateData(Date.now());
        })
        .catch((error) => console.log(error));
      }
    });
  };
  
  const exportData = (fileType, fileName) => {
    let exportData = data;
    
    const header = ["Name", "Status", "Type", "Code", "SAQA Link", "#NQF", "School", "Study Path Link", "Netsuite Product", "Articulation Options"];
    
    Swal.fire({
      title: "File downloading",
      didOpen: function () {
        Swal.showLoading();
      },
    });
    
    const payload = {
      page:tableState.page,
      limit:tableState.perPage,
      key:tableState.sortKey,
      sort:tableState.sortOrder,
      exportStatus:"true",
      search :search,
      viaStatus:status.arr,
      viaSchool:school.arr,
      viaType:type.arr,
      viaNqfLevel:NQF.arr,
    }
    
    GetListofProgramCancelToken(payload).then((res)=>{
      exportData = res.data;
      exportData = exportData.map((item) => {
        const matchedNetsuite = netsuiteList.find((i) => {
          return i.id == item.netsuite_product;
        });
        return {
          ...item,
          netsuite_product_name: matchedNetsuite ? matchedNetsuite.displayname : "-",
        };
      });
      exportData = exportData?.map((row) => ({
        ...row,
        Name: row?.name ? row?.name : "-",
        Status: row.status ? RenderPMCStatus(row.status).text : "",
        Type: row.qualification_type ? RenderProgrammeType(row.qualification_type).text : "-",
        Code: row.Code ? row.Code : "-",
        "SAQA Link": row.SAQA_Link ? row.SAQA_Link : "-",
        "#NQF": row?.NQF_Level ? row?.NQF_Level : "-",
        School: row.School ? RenderSchool(row.School).text : "-",
        "Netsuite Product": row.netsuite_product_name ? row.netsuite_product_name : "-",
        "Study Path Link": row.EnableStudypathLink ? "Yes" : "No",
        "Articulation Options": row.articulations ? row.articulations : 0
      }));
      
      if (fileType === "csv") {
        const csvString = Papa.unparse({ fields: header, exportData });
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });
        
        const blobURL = window.URL.createObjectURL(blob);
        
        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
          "text/csv",
          anchor.download,
          anchor.href,
        ].join(":");
        anchor.click();
        
        setTimeout(() => {
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        const compatibleData = exportData.map((row) => {
          const obj = {};
          header.forEach((col, index) => {
            obj[col] = row[col];
          });
          return obj;
        });
        
        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        return false;
      }
      if (fileType === "pdf") {
        const compatibleData = exportData.map((row) => {
          return [
            row["Name"],
            row["Status"],
            row["Type"],
            row["Code"],
            row["SAQA Link"],
            row["#NQF"],
            row["School"],
            row["netsuite_product_name"],
            row["EnableStudypathLink"],
            row["articulations"]
          ];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            minCellWidth: 5,
            halign: "left",
            fontSize: 8,
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }
    }).catch((err)=>{
      console.log(err)
    })
  };

  const studyPathOptions = [
    { value: 0, label: "No" },
    { value: 1, label: "Yes" }
  ];

  const articulationOptions = [
    { value: 0, label: "0" },
    { value: 1, label: "1-4" },
    { value: 2, label: "5-7" },
    { value: 3, label: "8+" }
  ];

  return (    
    <DataTableComponent
    data={dataProcessed}
    columns={columns}
    loading={loading}
    search={search}
    setSearch={setSearch}
    state={tableState}
    setState={setTableState}
    totalRows={totalRows}
    exportFunction={exportData}
    exportFileName={"Programme_List"}    
    filters={[
      {
        filterName: "Status",
        optionArr: filterData.status,
        state: status,
        setState: setStatus,
        renderLabelFunction: RenderPMCStatus,
      },
      {
        filterName: "Type",
        optionArr: filterData.type,
        state: type,
        setState: setType,
        renderLabelFunction: RenderProgrammeType,
      },
      {
        filterName: "NQF",
        optionArr: filterData.NQF,
        state: NQF,
        setState: setNQF,
        cell: (row) => <div title={row?.NQF_Level}>{row?.NQF_Level}</div>,
      },
      {
        filterName: "School",
        optionArr: filterData.school,
        state: school,
        setState: setSchool,
        renderLabelFunction : RenderSchool
      }, 
      {
        filterName: "Study Path",
        optionArr: studyPathOptions,
        state: enableStudypathLink,
        setState: setEnableStudypathLink,
        singleSelect: true,
        isOptionReversed: true
      },
      {
        filterName: "Articulations",
        optionArr: articulationOptions,
        state: articulations,
        setState: setArticulations,
        cell: (row) => <div title={row?.articulations}>{row?.articulations}</div>,
      }    
         
    ]}                
    tableButton={[
      <PermissionsGate
      RenderError={() => (
        <button
        className="btn btn-primary"
        title="Create New"
        disabled
        >
        <i className="fal fa-plus"></i>Create New
        </button>
      )}
      scopes={["pmcpadd"]}
      >
      <Link
      to={`/program-management-center/programmes/programme/add`}
      >
      <button className="btn btn-primary" title="Create New">
      <i className="fal fa-plus"></i>Create New
      </button>
      </Link>
      </PermissionsGate>
    ]}
    /> 
  );
};

export default Program;